//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoExpansionPanelDefault from './demos/DemoExpansionPanelDefault.vue'
import DemoExpansionPanelAccordion from './demos/DemoExpansionPanelAccordion.vue'
import DemoExpansionPanelFocusable from './demos/DemoExpansionPanelFocusable.vue'
import DemoExpansionPanelInset from './demos/DemoExpansionPanelInset.vue'
import DemoExpansionPanelModel from './demos/DemoExpansionPanelModel.vue'
import DemoExpansionPanelPopout from './demos/DemoExpansionPanelPopout.vue'
import DemoExpansionPanelIcon from './demos/DemoExpansionPanelIcon.vue'

// code
import {
  expansionPanelDefault,
  expansionPanelAccordion,
  expansionPanelFocusable,
  expansionPanelInset,
  expansionPanelModel,
  expansionPanelPopout,
  expansionPanelIcon,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoExpansionPanelDefault,
    DemoExpansionPanelAccordion,
    DemoExpansionPanelFocusable,
    DemoExpansionPanelInset,
    DemoExpansionPanelModel,
    DemoExpansionPanelPopout,
    DemoExpansionPanelIcon,
  },
  setup() {
    return {
      codeSnippets: {
        expansionPanelDefault,
        expansionPanelAccordion,
        expansionPanelFocusable,
        expansionPanelInset,
        expansionPanelModel,
        expansionPanelPopout,
        expansionPanelIcon,
      },
    }
  },
}
